import { share } from '@kk/h5-sdk';
import { store } from '@/store';
import toast from '@kk/toast';
import { useTrack } from '@/hooks/useTrack';



export function useShare () {
  const { trackBtn } = useTrack();

  function doShare (option: {
    title: string;
    desc: string;
    link?: string;
    shareImage: string;
    platform?: string;
  }) {
    if (store.state.blackListTeam) return;
    const shareLink = option.link || store.state.shareLink;
    if (!shareLink) {
      toast.show({
        text: '分享信息初始化失败',
      });
      return;
    }
    const platform = [
      {
        name: 'QQ',
        type: 1,
        title: option.title,
        desc: option.desc,
        link: `${shareLink}&visitsource=3`,
        image: option.shareImage,
      },
      {
        name: 'Wechat',
        type: 1,
        title: option.title,
        desc: option.desc,
        link: `${shareLink}&visitsource=2`,
        image: option.shareImage,
      },
    ];
    share({
      title: option.title,
      desc: option.desc,
      link: shareLink,
      image: option.shareImage,
      action: { type: 1 },
      extraParams: {
        contentType: 2,
        subjectId: '组队赚KK币',
        track: {},
      },
      platform: option.platform ? platform.filter(item => item.name === option.platform) : platform,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      callback: (res: any) => {
        const { code, data } = res;
        console.log('share callback', JSON.stringify(data));
        if (code === 200 && data.platform === 1) {
          trackBtn('微信分享');
        }
        if (code === 200 && data.platform === 5) {
          trackBtn('QQ分享');
        }
      },
    });
  }

  return doShare;
}
